export default "__VITE_ASSET__d6f48ce2__"